<template>
  <transition name="reservoir-target-fade">
    <div
      v-if="target && interaction && interaction.screenPosition"
      class="reservoir-target-overlay"
      :style="overlayStyle"
      :class="{ locked: isLocked }"
      aria-live="polite"
    >
      <div class="reservoir-target-ring" aria-hidden="true"></div>
      <section class="reservoir-preview" :class="{ 'is-locked': isLocked }">
        <header>
          <span class="target-kicker">{{ isLocked ? '已锁定 · 当前语音目标' : '水库目标 · Hover Preview' }}</span>
          <strong>{{ target.displayName || target.name }}</strong>
        </header>
        <div class="reservoir-preview-grid">
          <span>状态</span><b>{{ statusText }}</b>
          <span>水位</span><b>{{ valueText(snapshot.level, 'm') }}</b>
          <span>入库流量</span><b>{{ valueText(snapshot.inflow, 'm³/s') }}</b>
          <span>数据</span><b>{{ dataSourceText }}</b>
        </div>
        <footer>
          <span v-if="isLocked">请询问关于{{ target.displayName || target.name }}的问题</span>
          <span v-else>握拳锁定 · 语音询问</span>
          <button v-if="isLocked" type="button" @click.stop="$emit('unlock')">解除锁定</button>
        </footer>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ReservoirTargetOverlay',
  props: {
    interaction: { type: Object, default: () => ({}) },
    voice: { type: Object, default: () => ({}) },
  },
  computed: {
    isLocked() { return Boolean(this.interaction && this.interaction.locked) },
    target() {
      return this.isLocked
        ? this.interaction.selectedTarget
        : this.interaction.hoverTarget
    },
    targetData() { return (this.target && (this.target.data || this.target.businessData)) || {} },
    snapshot() { return this.targetData.snapshot || {} },
    statusText() {
      return this.targetData.status
        || this.targetData.warning
        || this.targetData.alarm
        || this.snapshot.status
        || '暂无结构化预警'
    },
    dataSourceText() {
      return String(this.targetData.sourceLevel || '').includes('demo') ? '演示数据' : '现有目录'
    },
    overlayStyle() {
      const point = this.interaction.screenPosition || { x: 0, y: 0 }
      const left = Math.max(12, Math.min(window.innerWidth - 320, point.x + 22))
      const top = Math.max(72, Math.min(window.innerHeight - 190, point.y - 26))
      return { left: `${left}px`, top: `${top}px` }
    },
  },
  methods: {
    valueText(value, unit) {
      return value === null || value === undefined || value === '' ? '暂无实时数据' : `${value} ${unit}`
    },
  },
}
</script>

<style scoped>
.reservoir-target-overlay {
  position: fixed;
  z-index: 10025;
  pointer-events: none;
  width: 292px;
}
.reservoir-target-ring {
  position: absolute;
  width: 42px;
  height: 42px;
  margin: -21px 0 0 -21px;
  border: 1px solid rgba(56, 248, 255, 0.88);
  border-radius: 50%;
  box-shadow: 0 0 0 5px rgba(56, 248, 255, 0.08);
  left: -22px;
  top: 26px;
  animation: target-pulse 1.8s ease-in-out infinite;
}
.locked .reservoir-target-ring {
  border-color: rgba(101, 246, 207, 0.95);
  box-shadow: 0 0 0 5px rgba(101, 246, 207, 0.12);
}
.reservoir-preview {
  pointer-events: none;
  color: #d9fbff;
  border: 1px solid rgba(56, 214, 240, 0.68);
  border-radius: 6px;
  background: rgba(7, 19, 32, 0.94);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}
.reservoir-preview.is-locked { border-color: rgba(101, 246, 207, 0.8); }
.reservoir-preview header { padding: 10px 12px 8px; border-bottom: 1px solid rgba(95, 211, 231, 0.18); }
.target-kicker { display: block; color: #55dce9; font-size: 10px; letter-spacing: 0; }
.reservoir-preview strong { display: block; margin-top: 4px; color: #fff; font-size: 16px; font-weight: 600; }
.reservoir-preview-grid { display: grid; grid-template-columns: 76px 1fr; gap: 5px 8px; padding: 9px 12px; font-size: 11px; }
.reservoir-preview-grid span { color: rgba(217, 251, 255, 0.58); }
.reservoir-preview-grid b { color: rgba(239, 255, 255, 0.92); font-weight: 500; }
.reservoir-preview footer { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 8px 12px; color: rgba(217, 251, 255, 0.68); background: rgba(20, 68, 82, 0.24); font-size: 10px; }
.reservoir-preview footer button { pointer-events: auto; border: 1px solid rgba(101, 246, 207, 0.5); border-radius: 4px; color: #a5ffe8; background: transparent; padding: 3px 7px; cursor: pointer; font-size: 10px; }
@keyframes target-pulse { 0%, 100% { transform: scale(.92); opacity: .72; } 50% { transform: scale(1.08); opacity: 1; } }
.reservoir-target-fade-enter-active, .reservoir-target-fade-leave-active { transition: opacity .16s ease, transform .16s ease; }
.reservoir-target-fade-enter, .reservoir-target-fade-leave-to { opacity: 0; transform: translateY(4px); }
</style>
